function TopHead() {
  return (
    <>
      <>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap"
          rel="stylesheet"
        />
      </>
      <div className="whole">
        <div className="row">
          <div className="first_four_images col-3 d-flex justify-content-evenly mt-1">
            <a href="">
              <img
                id="LFE"
                src="images\04-Life final logo.png"
                alt="LFE"
                width="105"
                height="55"
                style={{ marginTop: "10px", marginLeft: "4px" }}
              />
            </a>
            <a href="">
              <img
                id="G20"
                src="images\G20_India_2023_logo.png"
                alt="G20"
                width="95"
                height="65"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="EIACP"
                src="images\EIACP_Logo.png"
                alt="EIACP"
                width="63"
                style={{ marginTop: "5px", marginLeft: "8px" }}
              />
            </a>
            <a href="">
              <img
                id="ENVIS"
                src="images\ENVIS Logo_FINAL.png"
                alt="ENVIS"
                width="63"
                style={{ marginTop: "1px", marginLeft: "8px" }}
              />
            </a>
          </div>
          <div className="heading col-6" style={{ marginLeft: "0px" }}>
            <h5
              style={{
                textAlign: "center",

                color: "black",
                marginTop: "7px",
                marginLeft: "20px",
              }}
            >
              <b style={{ fontFamily: "'Nunito'", fontWeight: "bold" }}>
                ASSESSMENT OF CLIMATE TRENDS AND CARBON SEQUESTRATION IN FOREST
                ECOSYSTEM THROUGH INVEST
              </b>
              <br />

              <div
                style={{
                  fontSize: "0.8em",
                  color: "black",
                  fontFamily: "'Nunito'",
                }}
              >
                <strong>
                  T.V Ramachandra<sup>1,2,3*</sup>&nbsp;&nbsp;Tulika Mondal{" "}
                  <sup>1</sup>&nbsp;&nbsp;Paras Negi<sup>1</sup>
                  &nbsp;&nbsp;Bharath Setturu<sup>1,4</sup>{" "}
                </strong>
              </div>
              <div
                style={{ fontSize: "0.54em", color: "white" }}
                className="style33"
              >
                <span className="style16">
                  <sup>1</sup>Energy and Wetlands Research Group, Centre for
                  Ecological Sciences, Indian Institute of Science, India
                  <br />
                  <sup>2</sup>Centre for Sustainable Technologies (astra)
                  &nbsp;&nbsp;
                  <sup>3</sup>Centre for infrastructure, Sustainable
                  Transportation and Urban Planning (CiSTUP) Indian Institute of
                  Science, Bangalore – 560 012, India. &nbsp;&nbsp;
                  <sup>4</sup>Chanakya University, Bangalore
                  <br />
                  *Corresponding Author: tvr@iisc.ac.in, ORCID:
                  0000-0001-5528-1565
                </span>
                <span className="style16">
                  &nbsp;
                  <a
                    title="mailto:cestvr@ces.iisc.ac.in"
                    href="mailto:tvr@iisc.ac.in"
                  >
                    tvr@iisc.ac.in
                  </a>
                </span>
              </div>
            </h5>
          </div>

          <div
            style={{
              marginTop: "7px",
              marginRight: "0px",
            }}
            className="col-3 second_four_images  d-flex justify-content-evenly mt-1"
          >
            <a href="">
              <div style={{ mixBlendMode: "multiply" }}>
                <img
                  id="IISc"
                  src="images\IISc_Master_Seal.jpg"
                  alt="IISc"
                  width="78"
                />
              </div>
            </a>
            <a href="">
              <img src="images\EWRG_logo.png" alt="EWRG" width="70" />
            </a>
            <a href="">
              <img
                id="NE"
                src="images\National Emblem (1).png"
                alt=""
                width="60"
                style={{ marginTop: "3px" }}
              />
            </a>
            <a href="">
              <img
                src="images/azadi_ka_amrit_mahotsav_logo.png"
                alt="AKAM"
                width="100"
                height="65"
                style={{ marginTop: "5px" }}
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default TopHead;
